export const projects = [
  {
    id: 1,
    title: "E-Commerce Platform",
    description: "A full-stack online shopping platform with cart, payment integration, and admin dashboard.",
    technologies: ["React", "Node.js", "MongoDB", "Stripe"],
    github: "https://github.com",
    live: "https://vercel.com",
    image: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=500"
  },
  {
    id: 2,
    title: "Task Management App",
    description: "Collaborative task management application with real-time updates and team features.",
    technologies: ["Next.js", "Firebase", "Tailwind"],
    github: "https://github.com",
    live: "https://vercel.com",
    image: "https://images.unsplash.com/photo-1611224923853-80b023f02d71?w-500"
  },
  {
    id: 3,
    title: "Weather Dashboard",
    description: "Real-time weather application with 7-day forecast and location-based services.",
    technologies: ["React", "API Integration", "Chart.js"],
    github: "https://github.com",
    live: "https://vercel.com",
    image: "https://images.unsplash.com/photo-1592210454359-9043f067919b?w=500"
  }
];